// import { env } from './.env';

export const environment = {
  production: true,
  // version: env.npm_package_version,
  serverUrl: 'https://staging.tallify.in',
  appName: 'tallifysync',
  firebaseUrl:'https://tallify-442fc.firebaseio.com/tally'
};
